module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("al9m9"))).then(() => parcelRequire('iDabs'));